"use strict";
// Copyright © 2023 Move Closer
Object.defineProperty(exports, "__esModule", { value: true });
exports.stickyBarConfig = void 0;
const StickyBar_contracts_1 = require("./StickyBar.contracts");
exports.stickyBarConfig = {
    [StickyBar_contracts_1.StickyBarColor.Black]: 'bg-gray text-white',
    [StickyBar_contracts_1.StickyBarColor.Blue]: 'bg-blue text-white',
    [StickyBar_contracts_1.StickyBarColor.Brand]: 'bg-brand text-white',
    [StickyBar_contracts_1.StickyBarColor.Yellow]: 'bg-cta text-black',
    [StickyBar_contracts_1.StickyBarColor.Gray]: 'bg-gray-10 text-black',
    [StickyBar_contracts_1.StickyBarColor.Green]: 'bg-green text-white'
};
//# sourceMappingURL=StickyBar.config.js.map